
export const masktelefone = (value: String | undefined) => {
    
    if (!value) return ''
    
    return value.replace(/[\D]/g, '')
        .replace(/(\d{2})(\d)/, '($1) $2')
        .replace(/(\d{5})(\d)/, '$1-$2')
        .replace(/(-\d{4})(\d+?)/, '$1')

}


export const maskdocumento = (value: String | undefined) => {
    
    if (!value) return ''

    if(value.length < 15) {
        return value.replace(/\D/g, '') 
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d{1,2})/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    } else {
        return value.replace(/[\D]/g, '')
        .replace(/(\d{2})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1.$2')
        .replace(/(\d{3})(\d)/, '$1/$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(-\d{2})\d+?$/, '$1');
    }
}


export const maskcep = (value: string | undefined) => {
    
    if (!value) return '';
    
    return value
    
    .replace(/\D/g, "")                 // remove tudo que não é número
    .replace(/^(\d{5})(\d{0,3})/, "$1-$2") // insere o traço após 5 dígitos
    .replace(/-$/, "");                  // remove traço no final se não houver números

}


export const maskcartao = (value: string | undefined) => {
  
    if (!value) return '';

    return value
    
    .replace(/\D/g, '') // remove tudo que não for número
    .replace(/(\d{4})(?=\d)/g, '$1 ') // insere espaço a cada 4 dígitos
    .trim(); // remove espaço final se sobrar

};


export const maskvencimento = (value: string | undefined) => {
  
    if (!value) return '';

    // remove tudo que não for número e limita a 4 dígitos (MMYY)
    const digits = value.replace(/\D/g, '').slice(0, 4);

    // se tiver 2 ou mais dígitos, coloca a barra entre MM e YY
    return digits.replace(/^(\d{2})(\d{0,2})$/, (_m, mm, yy) => (yy ? `${mm}/${yy}` : mm));

};


export const maskdata = (value: string | undefined) => {
  
    if (!value) return '';

    return value
        .replace(/\D/g, '') // remove tudo que não for número
        .replace(/(\d{2})(\d)/, '$1/$2') // coloca a primeira barra depois do dia
        .replace(/(\d{2})\/(\d{2})(\d)/, '$1/$2/$3') // coloca a segunda barra depois do mês
        .slice(0, 8); // limita a 8 caracteres (dd/mm/aa)

};


    